module.exports = __webpack_public_path__ + "img/en.81100991.svg";